// extracted by mini-css-extract-plugin
module.exports = {"container":"normal_container__2x3Wy","inner":"normal_inner__vhUNE","title":"normal_title__9P_RI","content":"normal_content__1tP4w"};